import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["actions"]

  flip() {
    this.element.toggleAttribute("data-flipped")
    this.actionsTarget.classList.remove("hidden")
  }

  key(event) {
    if (event.code !== "Space" || event.target.closest("button, input, textarea, a")) return

    event.preventDefault()
    this.flip()
  }
}
